/* eslint-disable no-dupe-keys */ 
import React from 'react'
import { connect } from 'react-redux'
import debounce from 'debounce'
import Navigation from 'support/navigation'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './components/dialogs/ErrorSubmitContainer'
import ConfirmDeleteIdeaModal from './components/dialogs/ConfirmDeleteContainer'
import ConfirmEvaluatorDeleteIdeaModal from './components/dialogs/ConfirmEvaluatorDeleteContainer'
import ConfirmSubmitModalEvaluator from './components/dialogs/ConfirmSubmitContainerEvaluator'
import ConfirmEditModalEvaluator from './components/dialogs/ConfirmEditContainerEvaluator'
import ConfirmSubmitModalIdeaApprove from './components/dialogs/ConfirmSubmitContainerIdeaApprove'
import ConfirmSubmitContainer from './components/dialogs/ConfirmSubmitContainer'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import i18n from 'support/i18n'
import View from './View'
import { deleteInnovateUserFromTeam,getShowPopupForEvaluatorScorecardAssignedIdea,putAddBusinessScoreCard,getSearchByCommunutyUserEvaluatorSuggestions,postInnovateIdeaEvaluatorRatingSave,postAddInnovateIdeaTeamMembar,postInviteInnovateIdeaTeamMembar,getInnovateIdeaTeam,getUserValidateEvaluatorScorecardRole,getInnovateIdeaTemplateIdJson, putInnovateIdeaEvaluatorRatingEdit, putInnovateIdeaEvaluatorRatingSubmit ,getJsonRatedEvaluatorScorecard,getListEvaluatorAssignedForIdea,getScorecardJsonBasedOnChallengeTemplateId,getIdeaInnovateDetail,getUserEvaluatorSuggestions,postInnovateIdeaAddEvaluator,postInnovateIdeaAddSearchByCommunityEvaluator, getIdeaHistory, moveToDraft } from 'services/innovate/idea'
import { getScorecardTemplatelist } from 'services/innovate/templates'
import { getInnovateChallengeActiveTypes } from 'services/innovate/challenge'
import { getGroups , getSponsorSuggestions} from 'services/challenge_steps'
import { getChallengeById } from 'services/challenges'
import { requestJoinIdeaTeam } from 'services/ideas'
import { deleteUserFromTeam, getIdeaTeam , postSendInvitations} from 'services/create_idea'


const mapStateToProps = state => ({
  csrf:state.auth.csrf,
  idea: state.data.createIdea,
  innovateUserIsEvaluatorOrNot:state.data.InnovateIdea.innovateUserIsEvaluatorOrNot,
  innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
  isLoadingGetIdeaDetail:state.data.InnovateIdea.getInnovateIdeaIdDetailIsLoading,
  getIdeaDetailsResponse: state.data.InnovateIdea.getInnovateIdeaIdDetail,
  getJsonChallengeTemplateIdIsLoading: state.data.InnovateIdea.getJsonChallengeTemplateIdIsLoading,
  getJsonChallengeTemplateId: state.data.InnovateIdea.getJsonChallengeTemplateId,
  hasDomainLoaded: state.data.domain.dataLoaded,
  canSendPilotProjectTeamInvitations : state.data.createIdea.canSendPilotProjectTeamInvitations,
  canSendIdeaTeamInvitations: state.data.createIdea.canSendIdeaTeamInvitations,
  isAnonymous: state.data.createIdea.isAnonymous,
  pilotTeam: state.data.createIdea.pilotTeam,
  pendingInvitationsUsers: state.data.createIdea.pendingInvitationsUsers,
  pendingInvitationsPilotTeamUsers: state.data.createIdea.pendingInvitationsPilotTeamUsers,
  promoterEmail: state.data.createIdea.promoter.email,
  // isSearchingForUser: state.data.challengeSteps.sponsorStarted,
  // isAlreadyInvited: state.data.createIdea.isAlreadyInvited,
  ownerEmail: state.data.createIdea.owner,
  
  isOrganizationsActive: state.data.domain.domainConfiguration.isOrganizationsActive,
  organizationTitle: state.data.domain.domainConfiguration.organizationsName,

  contributors: state.data.createIdea.contributors,

  ownContribution: state.data.createIdea.ownContribution,
  isBudgetActive: state.data.domain.domainConfiguration.isBudgetActive,
  isTimeActive: state.data.domain.domainConfiguration.isTimeActive,
  isOtherActive: state.data.domain.domainConfiguration.isOtherActive,
  isContributionActive: state.data.domain.domainConfiguration.isContributionActive,
  loginUserEmail: state.data.user.userEmail,
  ideaStatusStepper: state.data.domain.domainConfiguration.ideaStatusStepper,
    isLoading:state.data.createIdea.isLoading,
  contributeCurrencySymbol: state.data.domain.domainConfiguration.contributeCurrencySymbol,
  currencyIcon: state.data.domain.domainConfiguration.currencyIcon,
  
  userBalance: parseInt(state.data.user.balance || 0, 10),
  isDraft: state.data.createIdea.isDraft,
  suggestions: state.data.ChallengeDraft.sponsorSuggestions,
  
  isAdmin: state.data.user.admin,
  isEvaluator: state.data.user.evaluator,
  localAdmin: state.data.user.localAdmin,
  localInnovator: state.data.user.localInnovation,
  isInnovator: state.data.user.isInnovator,
  isOwner: state.data.createIdea.owner === state.data.user.userEmail,
  isPromoter: state.data.createIdea.promoter.email === state.data.user.userEmail,
  userData: state.data.user,
  sameOrigin: state.data.user.countryId === state.data.createIdea.origin,
  isSearchingForUser: state.data.ChallengeDraft.sponsorStarted,
  
  rejectedReasons: state.data.domain.rejectedReasons,
  approvedReasons: state.data.domain.approvedReasons,
  currentIdeaStatusAfterInvest:state.data.createIdea.currentIdeaStatus,
  currentStatus: state.data.createIdea.status,
  statusMessageText: state.data.createIdea.statusMessageText,
  statusMessageTitle: state.data.createIdea.statusMessageTitle,
  feedbackFromNova: state.data.createIdea.feedbackFromNova,
  boardDecision: state.data.createIdea.boardDecision,
  pitchDecision: state.data.createIdea.pitchDecision,
  investmentIdea: state.data.createIdea.investment,

  documentIdeaKey:state.data.createIdea.documentIdeaKey,
  isDocumentLoading: state.data.createIdea.isDocumentLoading,
  csrfToken: state.auth.csrf,
  isInnovator: state.data.user.isInnovator,
  isHackathonEnable:state.data.domain.config.globalIsHackthon,
  userEvaluatorSuggestions:state.data.evaluation.userEvaluatorSuggestions,
  getSearchByCommunityUserInnovateIdeaSuggestions:state.data.evaluation.getSearchByCommunityUserInnovateIdea,
  getJsonEvaluatorForRating:state.data.evaluation.getJsonEvaluatorForRating,
  getListEvaluatorAssignedIdea:state.data.evaluation.getListEvaluatorAssignedIdea,
  getListEvaluatorAssignedIdeaIsLoading:state.data.evaluation.getListEvaluatorAssignedIdeaIsLoading,
  evaluationLoading:state.data.evaluation.evaluationLoading,
  getJsonEvaluatorForRatingIsLoading:state.data.evaluation.getJsonEvaluatorForRatingIsLoading,
  deleteAssignedEvaluatorIdeaIsLoading:state.data.evaluation.deleteAssignedEvaluatorIdeaIsLoading,
  getInnovateIdeaTemplateIdJsonLoading: state.data.InnovateIdea.getInnovateIdeaTemplateIdJsonLoading,
  getInnovateIdeaTemplateIdJson:state.data.InnovateIdea.getInnovateIdeaTemplateIdJson,
  postApproveIdeaIsLoading:state.data.InnovateIdea.postApproveIdeaIsLoading,
  getInnovateIdeaTeamIsLoading:state.data.InnovateIdea.getInnovateIdeaTeamIsLoading,
  getInnovateIdeaTeamData:state.data.InnovateIdea.getInnovateIdeaTeam,
  postInnovateIdeaScorecardSaveRatingIsLoading:state.data.InnovateIdea.postInnovateIdeaSaveRatingIsLoading,
  postInnovateIdeaScorecardSaveRating:state.data.InnovateIdea.postInnovateIdeaSaveRating,
  innovateShowPopupEvaluatorAssignedData:state.data.InnovateIdea.innovateShowPopupEvaluatorAssignedData,
  innovateShowPopupEvaluatorAssignedDataIsLoading:state.data.InnovateIdea.innovateShowPopupEvaluatorAssignedDataIsLoading,

  listScorecardTemplateLoading: state.data.templates.listScorecardTemplateLoading,
  innovateAddBusinessScoreCardIsLoading:state.data.InnovateIdea.innovateAddBusinessScoreCardIsLoading,
  listScorecardTemplate:state.data.templates.listScorecardTemplate,
  listCommunitesChallenge:state.data.InnovateChallenge.listInnovateCommunitesChallenge,
  // innovateShowPopupEvaluatorAssignedDataIsLoading:state.data.InnovateIdea.innovateShowPopupEvaluatorAssignedDataIsLoading,
  innovateChallengeTagIdeaCount : state.data.challenge.challengeById.numIdeas,

  isAlreadyInvited: state.data.InnovateIdea.isAlreadyInvited,
  ideaHistoryData: state.data.InnovateIdea.ideaHistoryData,
  ideaHistoryIsLoading: state.data.InnovateIdea.ideaHistoryIsLoading,

  })


const mapDispatchToProps = dispatch => {
 
  return {
    
    getIdeaDetailFn: (id)=>{
      dispatch(getIdeaInnovateDetail(id))
    },
    getInnovateIdeaTemplateIdJsonFn: (idIdeaTemplate)=>{
      dispatch(getInnovateIdeaTemplateIdJson(idIdeaTemplate))
    },
    getListEvaluatorAssignedForIdeaFn: (id)=>{
      dispatch(getListEvaluatorAssignedForIdea(id))
    },
    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
    getScorecardJsonBasedOnChallengeTemplateIdFn: (chalengeTemplateId)=>{
      console.log("🚀 ~ mapDispatchToProps ~ chalengeTemplateId======??????:", chalengeTemplateId)
      dispatch(getScorecardJsonBasedOnChallengeTemplateId(chalengeTemplateId))
    },
    handleEditIdeaInnovateFn: id =>{
      dispatch(Navigation.navigateToEditIdeaInnovate(id))
    },
    navigateToScorecardNewTabFn: (ideaIdKey,flag) =>{
      dispatch(Navigation.navigateToScorecardNewTab(ideaIdKey,flag))
    },
   
 

    deleteAssignedEvaluatorIntoIdeaFn : (deleteEvaluatorlistParams)=>{
      showPopupDialog(<ConfirmEvaluatorDeleteIdeaModal deleteEvaluatorlistParams={deleteEvaluatorlistParams} />, dispatch)
    },
    getJsonRatedEvaluatorScorecardFn: (getAccessJsonEvaluatorParams)=>{
      console.log("getAccessJsonEvaluatorParams==> +++++", getAccessJsonEvaluatorParams)
      dispatch(getJsonRatedEvaluatorScorecard(getAccessJsonEvaluatorParams))
    },
    
    postInnovateIdeaEvaluatorRatingSaveFn:(postSaveEvaluatorFormParams)=>{
      showPopupDialog(<ConfirmSubmitModalEvaluator postSaveEvaluatorFormParams={postSaveEvaluatorFormParams}  />, dispatch)
    },
    putInnovateIdeaEvaluatorRatingEditFn:(putEditEvaluatorFormParams)=>{
      // console.log("🚀 ~ mapDispatchToProps ~ putEditEvaluatorFormParams: Edit =====>", putEditEvaluatorFormParams)
      // dispatch(putInnovateIdeaEvaluatorRatingEdit(putEditEvaluatorFormParams))
       showPopupDialog(<ConfirmEditModalEvaluator postSaveEvaluatorFormParams={putEditEvaluatorFormParams}  />, dispatch)
    },
    putInnovateIdeaEvaluatorRatingSubmitFn:(putSubmitEvaluatorFormParams)=>{
      // console.log("🚀 ~ mapDispatchToProps ~ putSubmitEvaluatorFormParams:", putSubmitEvaluatorFormParams)
      dispatch(putInnovateIdeaEvaluatorRatingSubmit(putSubmitEvaluatorFormParams))
    },
    postInnovateIdeaApproveFn:(ideaApproveParams)=>{
      showPopupDialog(<ConfirmSubmitModalIdeaApprove ideaApproveParams={ideaApproveParams}  />, dispatch)
      // dispatch(postInnovateIdeaApprove(ideaApproveParams,onSuccess,onFailure))
    },
    getUserValidateEvaluatorScorecardRoleFn:(checkParamsEvaluatorOrNot)=>{
      dispatch(getUserValidateEvaluatorScorecardRole(checkParamsEvaluatorOrNot))
    },
    
    getShowPopupForEvaluatorScorecardAssignedIdeaFn:(paramsForShowPopupData)=>{
      // console.log("show assign data", paramsForShowPopupData)
      dispatch(getShowPopupForEvaluatorScorecardAssignedIdea(paramsForShowPopupData))
    },
    
    getInnovateIdeaTeamFn:(ideaIdParams)=>{
      dispatch(getInnovateIdeaTeam(ideaIdParams))
    },
    navigateToUserProfile: userEmail => {
      Navigation.navigateToUserProfile(userEmail)
    },

    getScorecardTemplatelistFn: ()=>{
      dispatch(getScorecardTemplatelist())
    }, 

    
    getCommunitesAsGroup : ()=> dispatch(getGroups()), 
    getChallengeById: (id, limit = 10, offset = 0) => {
      dispatch(getChallengeById(id, limit, offset))
    },
  
    


    
  }
 
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)